<template>
  <div v-if="isPagingTypeLoadMore" class="ta-load-more-wrapper mt-3 text-center">
    <button class="btn btn-primary" @click="updatePagination">
      {{ $t('Load More') }}
    </button>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "LotListLoadMore",
  computed: {
    ...mapState(['lotQueryParams', 'lots']),
    ...mapGetters(['isPagingTypeLoadMore'])
  },
  methods: {
    ...mapActions(['getLots']),
    ...mapMutations(['setLotFilters', 'setPreserveOldLots']),
    async updatePagination() {
      if (this.lots.totalRows > this.lots.results.length) {
        this.$emit('startFetchingLots');
        this.setLotFilters({page: parseInt(this.lotQueryParams.page) + 1});
        await this.getLots({stopLoading: true});
        this.$emit('stopFetchingLots');
      }
    }
  },
  mounted() {
    this.setPreserveOldLots(true);
  },
  destroyed() {
    this.setPreserveOldLots(false);
  }
}
</script>

<style scoped>

</style>
